import React from "react";
import { Marker, Popup } from "react-map-gl/maplibre";
import airportMarker from "../../../assests/map-markers/airportMarker.svg";
import { MAPLIBRE_Z_INDEX } from "../../../utils/maps/MapConstants";
import {
  MARKER_TOOLTIP_PRIORITY,
  useMapTooltip,
} from "../context/MapTooltipContext";
import { mapLibreStyles } from "../map-displays/mapStyles";
import { isValidLatLng, toLngLat } from "../utils/coordinates";

export interface AirportMarkerProps {
  code: string;
  name: string;
  position: [number, number];
  onClick?: () => void;
}

const AirportMarker: React.FC<AirportMarkerProps> = ({
  code,
  name,
  position,
  onClick,
}) => {
  const styles = mapLibreStyles();
  const { isTooltipVisible, showTooltip, hideTooltip } = useMapTooltip(
    `airport:${code}`,
    MARKER_TOOLTIP_PRIORITY
  );

  if (!isValidLatLng(position)) {
    return null;
  }

  const [longitude, latitude] = toLngLat(position);

  return (
    <>
      <Marker
        longitude={longitude}
        latitude={latitude}
        anchor="center"
        style={{ zIndex: MAPLIBRE_Z_INDEX.MARKER }}
      >
        <button
          type="button"
          className={styles.markerButton}
          aria-label={`${code} - ${name}`}
          onClick={onClick}
          onMouseEnter={showTooltip}
          onMouseLeave={hideTooltip}
          onFocus={showTooltip}
          onBlur={hideTooltip}
        >
          <img className={styles.airportMarker} src={airportMarker} alt="" />
        </button>
      </Marker>
      {isTooltipVisible && (
        <Popup
          longitude={longitude}
          latitude={latitude}
          anchor="bottom"
          offset={22}
          closeButton={false}
          closeOnClick={false}
        >
          {code} - {name}
        </Popup>
      )}
    </>
  );
};

export default AirportMarker;
